<app-prism-xml></app-prism-xml>
<div *ngFor="let section of sections">
  <h2>{{ section.title }}</h2>
  <div class="rbrd mb-30">
    <p>{{ section.body }}</p>
    <div>
      <app-prism-xml [xmlData]="section.xmlData"></app-prism-xml>
      <div [innerHtml]="section.subBody! | mdToHtml"></div>
    </div>
    <div *ngIf="section.tableSections">
      <app-table-section [tableSections]="section.tableSections"></app-table-section>
    </div>
    <!-- <div *ngIf="section.tables">
      <div [innerHtml]="section.tables![0] | mdToHtml"></div>
      <table class="table table-bordered">
        <thead class="thead-blue">
          <tr>
            <th *ngFor="let thead of section.tables![1]">{{ thead }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tBodyRow of section.tables![2]">
            <td *ngFor="let data of tBodyRow">{{ data }}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
  </div>
</div>
